/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Form as UForm } from '@unform/web';
import Layout from 'components/Layout';
import { GrServices } from 'react-icons/gr';
import { useHttp } from 'hooks/http';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import { Grid } from '@material-ui/core';
import {
  Button, ButtonIcon, Input, WrapperLabel,
} from 'components/Forms';
import { useHistory, useParams } from 'react-router-dom';
import getValidationErrors from 'utils/getValidationsErros';
import { useToast } from 'hooks/toast';
import { InfoIcon } from 'styles/icons';
import {
  Container, Content, GridButtons, WrapperBtnCancel, WrapperBtnInfo, WrapperBtnSubmit,
} from './styles';

interface Params {
  id: string;
}

const ServiceRJProfile: React.FC = () => {
  const history = useHistory();
  const { httpGet , httpPut, loading } = useHttp();
  const formRef = useRef<FormHandles>(null);
  const labelRef = useRef<HTMLLabelElement>(null);
  const [btnLoading, setBtnLoading] = useState(false);
  const { addToast } = useToast();
  const { id } = useParams<Params>();

  useEffect(() => {
    async function loadService() {
      try {
        const { data } = await httpGet(`social-action/services/${id}`);
        formRef.current?.setData({
          service_name: data.service_name,
        });
      } catch (error) {
        addToast({ title: 'Erro ao carregar serviço', type: 'error' });
        history.push('/social-action/services');
      }
    }

    loadService();
  }, [id]);

  const handleSubmit = useCallback(async (data: any) => {
    try {
      setBtnLoading(true);

      const schema = Yup.object().shape({
        service_name: Yup.string().required('Nome do serviço é obrigatório'),
      });

      await schema.validate(data, { abortEarly: false });

      const { status } = await httpPut(`social-action/services/${id}`, {
        service_name: data.service_name,
      });

      setBtnLoading(false);

      if (status === 200) {
        addToast({ title: 'Serviço editado com sucesso!', type: 'success' });
        history.push('/social-action/services');
      } else {
        addToast({ title: 'Não foi possível editar o serviço' });
      }
    } catch (error) {
      setBtnLoading(false);
      if (error instanceof Yup.ValidationError) {
        const erros = getValidationErrors(error);
        formRef.current?.setErrors(erros);
      } else {
        addToast({ title: 'Erro inesperado', type: 'error' });
      }
    }
  }, [addToast, history, httpPut, id]);

  const breadcrumbs = {
    icon: GrServices,
    links: [{ path: '', title: 'Editar Serviço' }],
  };

  return (
    <Layout breadcrumbs={breadcrumbs} loading={loading}>
      <Container>
        <Content>
          <UForm ref={formRef} onSubmit={handleSubmit}>
            <Grid container spacing={1}>
              <WrapperLabel label="Editar serviço" xs={12}>
                <Input
                  name="service_name"
                  style={{ textTransform: 'uppercase' }}
                />
              </WrapperLabel>
            </Grid>
            <GridButtons>
              <WrapperBtnInfo>
                <ButtonIcon
                  title="Instruções"
                  onClick={() => labelRef.current?.click()}
                >
                  <InfoIcon />
                </ButtonIcon>
              </WrapperBtnInfo>
              <WrapperBtnCancel>
                <Button
                  type="button"
                  onClick={() => { history.push('/social-action/services'); }}
                >
                  Cancelar
                </Button>
              </WrapperBtnCancel>
              <WrapperBtnSubmit>
                <Button
                  type="submit"
                  isLoading={btnLoading}
                >
                  Enviar
                </Button>
              </WrapperBtnSubmit>
            </GridButtons>
          </UForm>
        </Content>
      </Container>
    </Layout>
  );
};

export default ServiceRJProfile;
